import React from 'react'

export type FormContextData = {
  scope?: string
}
export const FormContext = React.createContext<FormContextData>({})
